import { logger } from "src/lib/utils";
import { useModalState } from "./context";

const CardUserDetailsModal = () => {
  const { data } = useModalState();
  const userData = data?.data?.user_data;
  return (
    <div className="p-6 bg-white rounded-xl w-full max-w-lg">
      <div className="border-b border-gray-200 pb-4 mb-5">
        <h2 className="text-2xl font-semibold text-gray-800">
          Card User Details
        </h2>

        <p className="text-sm text-gray-500 mt-1">
          User information linked with this card
        </p>
      </div>

      <div className="bg-gray-50 rounded-xl p-5 border border-gray-200 shadow-sm">
        <div className="grid grid-cols-1 gap-4">
          <div className="flex flex-col">
            <span className="text-xs font-medium text-gray-500 uppercase">
              User ID
            </span>

            <span className="text-base font-semibold text-gray-800 mt-1">
              {data?.data?.user_id || "-"}{" "}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-xs font-medium text-gray-500 uppercase">
              Full Name
            </span>

            <span className="text-base font-semibold text-gray-800 mt-1">
              {userData?.first_name || "-"} {userData?.last_name || ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardUserDetailsModal;
